import { createEnv } from '@t3-oss/env-nextjs'
import { vercel } from '@t3-oss/env-nextjs/presets-zod'
import { z } from 'zod'

import { analyticsEnv } from '@package/analytics/env'
import { authEnv } from '@package/auth/env'
import { sdkEnv } from '@package/sdk/env'
import { utilsEnv } from '@helper/utils/env'

export const env = createEnv({
  extends: [analyticsEnv(), authEnv(), sdkEnv(), utilsEnv(), vercel()],

  server: {
    NEXT_RUNTIME: z.enum(['nodejs', 'edge']).optional(),
    PIBO_CLIENT_ID: z.string().min(1),
    PIBO_CLIENT_SECRET: z.string().min(1),
  },

  // These NEXT_PUBLIC_ vars must be declared here (not just extended from
  // analyticsEnv, which registers them as *server* vars) — env-nextjs only
  // inlines a var into the client bundle when it appears in `client`.
  client: {
    NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_HOST: z.url().default('https://n.bacapibo.com'),
    NEXT_PUBLIC_POSTHOG_UI_HOST: z.url().default('https://us.posthog.com'),
  },

  experimental__runtimeEnv: {
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_POSTHOG_UI_HOST: process.env.NEXT_PUBLIC_POSTHOG_UI_HOST,
  },
})
